export type ChatAttachmentType = 'file' | 'image'

export type ChatAttachmentSource = 'computer' | 'clipboard' | 'chat'

export type ChatAttachmentUploadStatus = 'idle' | 'uploading' | 'complete' | 'error'

export interface ChatAttachment {
  id: string

  type: ChatAttachmentType

  name: string

  size: number

  mimeType: string

  source: ChatAttachmentSource

  previewUrl?: string

  file?: File

  chatId?: string

  chatMessageId?: string

  uploadProgress?: number

  uploadStatus?: ChatAttachmentUploadStatus
}

export const MAX_IMAGE_ATTACHMENTS = 5

export const IMAGE_PREVIEW_HEIGHT = 80

export const FILE_ICON_MAP: Record<string, string> = {
  'application/pdf': 'FileText',
  'application/msword': 'FileText',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'FileText',
  'application/vnd.ms-excel': 'FileSpreadsheet',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'FileSpreadsheet',
  'application/vnd.ms-powerpoint': 'FileImage',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'FileImage',
  'text/plain': 'FileText',
  'text/csv': 'FileSpreadsheet',
  'application/json': 'FileCode',
  'application/zip': 'FileArchive',
  'application/x-rar-compressed': 'FileArchive',
  default: 'File',
}

export const getFileIconName = (mimeType: string): string =>
  FILE_ICON_MAP[mimeType] ?? FILE_ICON_MAP.default

export const isImageAttachment = (attachment: ChatAttachment): boolean =>
  attachment.type === 'image'

export const isFileAttachment = (attachment: ChatAttachment): boolean => attachment.type === 'file'

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B'

  const units = ['B', 'KB', 'MB', 'GB']
  const k = 1024
  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${Number.parseFloat((bytes / k ** i).toFixed(1))} ${units[i]}`
}
